export const palette = {
  text: '#141921', // TEXT is now standardized to #141921
  greyText: '#141921',
  lightGreyText: '#4D5461',
  lightGray: '#727c8b',
  lightGrayBright: '#ABB0B9',
  darkGray: '#2C333D',
  snowFlower: '#CD395C',
  lightGrayishPink: '#E4DFE0',
  sierraRain: '#607D8B',
  midnightCharcoal: '#292D34',
  white: '#FFFFFF',
  darkerWhite: '#f4f6fa',
  cream: '#F7F0EA',
  lightBlue: '#f2fafa',
  lightSierraRain: '#e9f5f8',
  black: '#000000',
  fog: '#ECEBE8',
  water: '#D8EFF5',
  coldWater: '#D7EFF4',
  lavender: '#E9E3FB',
  solitudeFog: '#f4f6fa',
  alabasterWhisper: '#F5F1ED',
  blueViolet: '#8638ff',
  placeholder: '#9e9fa1',
  mightyViolet: '#2d263b',
  deepPurple: '#411783',
  darkPurple: '#330E6D',
  mightyProLight: '#e9f5f8',
  proBlue: '#1cabbf',
  softRed: '#ff7062',
  footerBackground: '#2d263b',
  steelTeal: '#607d8b',
  purple: '#963481',
  goldenYellow: '#e7b556',
  amber: '#DAAE55',
  straw: '#E7CB92',
  wood: '#5d6438',
  lightGreen: '#80d1cd',
  gold: '#ffdf6e',
  livingCoral: '#ff7062',
  givry: '#f1b6b0',
  blackSqueeze: '#f2fbfa',
  engagementDropBackground: '#3d157d',
  engagementDropLinkText: '#411783',
  pricingLightGreen: '#0BA611',
  pricingLightRed: '#F11046',
  catskillWhite: '#edf8fa',
  mightyExclusive: '#90317C',
  magenta: '#FF00FF',
  proDarkBlue: '#3B1F7E',
  proYellow: '#D7F055',
  softBlue: '#80D1CD',
  seaTurquoise: '#7FBAC9',
  proLightGreen: '#11808F',
  emailInput: '#C7CBD2',
  aeroBlue: '#C0E8E6',
  topaz: '#00B6C6',
  atlantis: '#A1CB2A',
  heliotrope: '#C366F7',
  brightPurple: '#A020F0',
  fountainBlue: '#00B7CA',
  whiteSmoke: '#F6F6F6',
  seaweedGreen: '#33AD6B',
  irisBlue: '#00B8C8',
  mercury: '#E6E7EA',
  aqua: '#2DD887',
  chineseBlack: '#10141B',
  neonSilver: '#C6CBD3',
  brandedLightGreen: '#CEF63E',
  auroMetalSaurus: '#6F7682',
  darkGunMetal: '#20252c',
  errorRed: '#E04247',
  softErrorRed: '#F0D2D6',
  softPurple: '#ECE7FA',
  bondiBlue: '#0098A6',
  darkerPurple: '#2F125C',
  standardYellow: '#FFF68A',
  lavenderCreek: '#D4CCCD',
  blueWhite: '#D1E6EC',
  accentBlue: '#007D7D',
  lightTeal: '#A2D1D0',
  wheat: '#DFCFBD',
  darkerWheat: '#D6C5B2',
  darkAccentBlue: '#102D33',
  spruce: '#004949',
  lightWheat: '#F7F0EA',
  darkSilver: '#6E6F70',
  sunshine: '#FAF118',
  sunglow: '#FFBE3B',
  purpleNavy: '#52588F',
  orange: '#BD6C27',
  jellyBlue: '#3D7D99',
  grapePurple: '#6C4366',
};

export type PaletteKeys = keyof typeof palette;

export type Color = PaletteKeys | (() => string);

export const setColor = (color: Color): string => (typeof color === 'function' ? color() : palette[color]);

export const setColorWithOpacity = (color: Color, opacity: number): string => {
  const selectedColor = typeof color === 'function' ? color() : palette[color];
  const rgbaColor = selectedColor.replace('#', '');
  const r = parseInt(rgbaColor.substring(0, 2), 16);
  const g = parseInt(rgbaColor.substring(2, 4), 16);
  const b = parseInt(rgbaColor.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};
